import POURCENTAGE_SIZE from '@/configuration/excel/excelConf';

export default function getSizeColumn(dataExcel) {
  const tabSizeCol = [];
  dataExcel.forEach((ligne) => {
    Object.keys(ligne).forEach((key) => {
      const dataOfKey = ligne[key];
      const keyLigneInformation = tabSizeCol.find(ligne => {
        return ligne.key === key;
      });
      if (keyLigneInformation && dataOfKey) {
        if (dataOfKey.toString().length >= keyLigneInformation.width) {
          keyLigneInformation.width = dataOfKey.toString().length * POURCENTAGE_SIZE;
        }
      } else {
        const keyLineObject = { width: 0, key: key };
        if (!dataOfKey || (key.length > dataOfKey.toString().length)) {
          keyLineObject.width = key.length * POURCENTAGE_SIZE;
        } else {
          keyLineObject.width = dataOfKey.toString().length * POURCENTAGE_SIZE;
        }
        tabSizeCol.push(keyLineObject);
      }
    });
  });
  return tabSizeCol;
}
